
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"160","height":"304"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M135.7 304H26.3C12.9 304 2 293.1 2 279.7V26.3C2 12.9 12.9 2 26.3 2h109.3C149.1 2 160 12.9 160 26.3v253.3c0 13.5-10.9 24.4-24.3 24.4zM26.3 4C14 4 4 14 4 26.3v253.3C4 292 14 302 26.3 302h109.3c12.3 0 22.3-10 22.3-22.3V26.3C158 14 148 4 135.7 4H26.3zM0 31h2v14H0zM0 56h2v19H0zM0 89h2v20H0z"}}),_c('path',{attrs:{"d":"M93 34H68c-1.7 0-3-1.3-3-3s1.3-3 3-3h25c1.7 0 3 1.3 3 3s-1.3 3-3 3zm-25-4c-.6 0-1 .4-1 1s.4 1 1 1h25c.6 0 1-.4 1-1s-.4-1-1-1H68zM80 290c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14zm0-26c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zM107 0h27v3h-27z"}}),_c('g',[_c('path',{attrs:{"d":"M13 49h136v202H13z","opacity":".1"}}),_c('path',{attrs:{"d":"M150 252H12V48h138v204zm-136-2h134V50H14v200z"}})]),_c('g',[_c('path',{attrs:{"d":"M13 251l49.6-73.7m37.7-56L149 49","opacity":".1"}}),_c('path',{attrs:{"d":"M13.8 251.6l-1.7-1.1 49.6-73.7 1.7 1.1-49.6 73.7zm87.3-129.7l-1.7-1.1 48.7-72.3 1.7 1.1-48.7 72.3z"}})]),_c('g',[_c('path',{attrs:{"d":"M57 34c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"}})])])
          )
        }
      }
    